var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages-container"},_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,staticClass:"message"},[(message)?_c('p',[_vm._v(_vm._s(message.text))]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }